export default {
	text: "{changedBy} assigned this KR to {to} (previously assigned to {from})",
};
